import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { RedirectHandler } from '@/components/feature/RedirectHandler';
import { ScrollToTop } from '@/components/ScrollToTop';
import MobileStickyCTA from '@/components/feature/MobileStickyCTA';
import SocialProofPopup from '@/components/feature/SocialProofPopup';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollToTop />
      <RedirectHandler />
      <AppRoutes />
      <MobileStickyCTA />
      <SocialProofPopup />
    </BrowserRouter>
  );
}

export default App;